var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cards_list_wrapper",attrs:{"id":_vm.cardListId}},[_c('div',{staticClass:"cards_list"},[_vm._t("cardsList")],2),_vm._t("cardsListHelpers")],2)}
var staticRenderFns = []

export { render, staticRenderFns }